import React, {useEffect, useRef, useState} from 'react'
import {useHistory, useLocation} from 'react-router';
import _ from 'lodash'
import {
    Button,
    Radio,
    FormControlLabel,
    MenuItem, Checkbox,

} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {CameraIcon, Container, Page, ChangeRoleBlock, ErrorDescription, HiddenInput} from "./SignUp2_Talent.styles";

import { HygienistSkill, roles } from "utils/constants";
import {getTypeByRoleNumber, uploadPhoto, getRoleByTypeNumber} from "utils";
import MaterialInput from "../../../components/Inputs/MaterialInput";
import {MaterialSelector} from "../../../components/Selector";
import {UserAccountProps, HYGIENIST_TYPES, HygienistProps, SkillsProps} from "utils/types";
import Api from "../../../api";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import GreenCheckmarkWithText from "../../../components/GreenCheckmarkWithText";
import FullscreenModal from "../../../components/FullscreenModal";
import clsx from "clsx";
import AdditionalSkills from "../../../components/AdditionalSkills";
import {Label} from "../../../components/AdditionalSkills/AdditionalSkills";
import WorkExperience from "./components/WorkExperience";
import {AboutYou} from "./components/AboutYou";
import {SimpleModal} from "components/Modal";
import LeftHandedModal from "./components/LeftHandedModal";
import AssistantSkillsCheckModal from "./components/AssistantSkillsCheckModal";
import AboutMeCompletedModal from "./components/AboutMeCompletedModal";
import {usePersistedState, usePersistedApi} from "../../../hooks";
import entities from "../../../reduxStore/entityKeys";
import {useActionApi} from "../../../hooks";
import FixedLoader from 'components/FixedLoader/FixedLoader';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


declare let cordova: any

// @ts-ignore
const TempStars = window.TempStars;
// @ts-ignore
const app = window.app;
// @ts-ignore
const Template7 = window.Template7

const supportLink= 'https://support.tempstars.com/hc/en-us/requests/new?'

const LEFT_HANDED_OPTIONS = {
    NOT_LEFT_HANDED: 0,
    LEFT_HANDED: 1,
}

interface ErrorProps {
    license: string,
    education: string,
    graduationYear: string,
    about: string,
    photo?: string,
    qualification?: string,
    creationError?: string,
    licensed?: boolean,
    isLeftHanded?: boolean,
}

interface LocationState {
    updatedHygienist?: HygienistProps;
    email?: string;

}

const hygienistMenuInit = (user: any) => {
    const contentForMenu = {
        fullname: _.capitalize( user.hygienist.firstName ) + ' ' + _.capitalize( user.hygienist.lastName ),
        city: _.trim( user.hygienist.city ),
        province: user.hygienist.province,
        photoUrl: (user.hygienist.photoUrl) ? user.hygienist.photoUrl : 'img/hygienist.png',
        type: user.hygienist.type,
    };

    const template = document.getElementById("hygienist-menu")?.innerHTML;
    const compiledTemplate = Template7.compile(template);
    const panel = document.getElementById("panel-menu");
    panel && (panel.innerHTML = compiledTemplate(contentForMenu));
}

export default function SignUp2_Talent() {
    const history = useHistory();

    const location = useLocation<LocationState>();
    const { updatedHygienist } = location.state || {};
  
    const [hygienist, setHygienist] = useState(
        updatedHygienist ? updatedHygienist as HygienistProps : {} as HygienistProps
    );

    let duplicate = false;

    const [
      userAccount,
      hygienistUserLoading,
      hygienistUserError,
      getHygienistUser
    ] = usePersistedApi({
      apiMethod: Api.getUser,
      entityName: entities.user,
      initialValue: {} as UserAccountProps
    });
  
    useEffect(() => {
      if (!updatedHygienist && !hygienistUserLoading) {
        getHygienistUser({});
      }
    }, []);

    useEffect(() => {
      if (!updatedHygienist && userAccount?.hygienist) {
        setHygienist(userAccount.hygienist);
      }
    }, [userAccount?.hygienist]);

    const province = hygienist?.province
    const country = hygienist?.country
    const hygienistId = hygienist?.id

    const roleNumber = getRoleByTypeNumber(hygienist?.type);
    const isHygienistOrAssistant = roleNumber === roles.HYGIENIST || roleNumber === roles.ASSISTANT

    let userRole: string | undefined;
    let license: string | undefined = undefined;
    let userRoleAnalytics: string | undefined = undefined;

    switch (roleNumber) {
        case roles.HYGIENIST:
            userRole = 'Dental Hygienist';
            userRoleAnalytics = 'Hygienist'
            license = 'Hygiene License #'
            break;
        case roles.ASSISTANT:
            userRole = 'Dental Assistant';
            userRoleAnalytics = 'Assistant'
            license = 'Assistant Certificate #'
            break;
        case roles.FRONT_DESK:
            userRole = 'Dental Admin / Manager';
            userRoleAnalytics = 'Admin'
            break;
        case roles.ASSOCIATE_DENTIST:
            userRole = 'Associate Dentist';
            userRoleAnalytics = 'Associate'
            license = 'Dental License #'
            break;
        default:
            roleNumber satisfies never;
    }

    useEffect(() => {
        if (country !== undefined && province !== undefined && !analyticsTracked.current) {
            TempStars.Analytics.track('view_talent_createAccount', {
                country: country === 0 ? 'CA' : 'US',
                province: province || '',
                userRole: userRoleAnalytics || ''
            });
            analyticsTracked.current = true;
        }
    }, [country, province, userRoleAnalytics]);
    
    const [screenError, setScreenError] = useState<string | undefined>();
    const inputPhotoRef = useRef<HTMLInputElement>(null)
    const htmlElRef = useRef<HTMLInputElement>(null)
    const submitRef = useRef<HTMLInputElement>(null)
    const [imageSrc, setImageSrc] = useState<string | undefined>()
    const [isOpenQualificationModal, setOpenQualificationModal] = useState<boolean>(false);
    const [isOpenAboutModal, setOpenAboutModal] = useState<boolean>(false);
    const [isOpenPositionModal, setOpenPositionModal] = useState<boolean>(false);
    const [isQualificationFilled, setQualificationFilled] = useState<boolean | undefined>();
    const [isWorkExperienceFilled, setWorkExperienceFilled] = useState<boolean | undefined>();
    const [isAboutFilled, setAboutFilled] = useState<boolean | undefined>();
    const [userQualification, setUserQualification] = useState<string | undefined>();
    const [userQualificationTitle, setUserQualificationTitle] = useState<string | undefined>();
    const [skills, setSkills] = useState<HygienistSkill[]>([]);
    const [checkedSkills, setCheckedSkills] = useState<HygienistSkill[]>([]);
    const [licensed, setLicensed] = useState<boolean | undefined>(isHygienistOrAssistant ? undefined : true);
    const [isLeftHanded, setIsLeftHanded] = useState<boolean>(false);
    const [isLeftHandedModal, setIsLeftHandedModal] = useState<boolean>(false);
    const [isAssistantSkillsCheckModal, setAssistantSkillsCheckModal] = useState<boolean>(false);
    const [isAboutMeCompletedModal, setAboutMeCompletedModal] = useState<boolean>(false);
    const [skipAboutMe, setSkipAboutMe] = useState<boolean>(false);
    const [formData, setFormData] = useState({});
    const [about, setAbout] = useState<string>('');
    const [disabledSkills, setDisabledSkills] = useState<boolean>(isHygienistOrAssistant);
    const analyticsTracked = useRef(false);

    const setUser = usePersistedState({
        entityName: entities.user,
    })[1];

    useEffect(() => {
        if (isHygienistOrAssistant && roleNumber && province) {
            getSkills();
        }
    },[roleNumber, province])

    useEffect(() => {
        if (typeof isAboutFilled === 'boolean' || !!about.length) {
            setAboutFilled(!!about.length)
        }
    },[about])

    useEffect(() => {
        if (country !== undefined && province !== undefined && !analyticsTracked.current) {
            TempStars.Analytics.track('view_talent_createAccount', {
                country: country === 0 ? 'CA' : 'US',
                province: province || '',
                userRole: userRoleAnalytics || ''
            });
            analyticsTracked.current = true;
        }
    }, [country, province, userRoleAnalytics]);

    useEffect(() => {
        if (roleNumber === roles.HYGIENIST && licensed) {
            setUserQualificationTitle('RDH')
        }
        if (roleNumber === roles.HYGIENIST && !licensed) {
            setUserQualificationTitle(undefined)
        }
        if (roleNumber === roles.ASSISTANT && licensed) {
            setUserQualificationTitle(userQualification || 'CDA')
        }
        if (roleNumber === roles.ASSISTANT && (licensed === false)) {
            setUserQualificationTitle('DA')
        }
    },[roleNumber, licensed, userQualification])

    useEffect(() => {
        if (isOpenQualificationModal) {
            document.querySelector( '#bodySignUp' )?.scrollIntoView( { block: 'start' } )
        }
    },[isOpenQualificationModal])

    const getSkills = async () => {
        const skills = await Api.getSkills({type: getTypeByRoleNumber(roleNumber), state: province});
        setSkills(skills);
    }

    const [errorMessage, setErrorMessage] = useState<ErrorProps>({
        license: '',
        education: '',
        graduationYear: '',
        about: '',
    });

    const contactSupport = () => {
        window.cordova?.platformId === 'ios' ?
            cordova.InAppBrowser.open(
                supportLink,
                '_blank',
                'location=yes'
            )
            : window.open(
                supportLink,
                '_blank',
                'location=yes'
            )
    }

    const completeSignUpWithErrors = (userAccount: any) => {
        history.push('loading');
        TempStars.Api.addToMailchimp(hygienist?.id || userAccount.hygienistId, userAccount.email)
        TempStars.Menu.logoutWoModal()
    }

    const sendAnalytic = (userAccount: any) => {
        const countryStr = country ? 'US' : 'CA';
        const props = {
            userType: "Dental Worker",
            userRole: userRoleAnalytics,
            userStatus: 0,
            country: countryStr,
            province: province,
            $email: userAccount.email,
        }
        TempStars.Analytics.setProfileProperties({
            ...props,
        });
        TempStars.Analytics.register({
            ...props,
            appType: window.cordova ? 'Mobile' : 'Web',
        })
    }

    const onSubmit = async (event: any) => {
        event.preventDefault()
        submitRef?.current?.click()
        const {graduationYear, photoUrl, qualification, education} = event.target
        let errors = {}
        let baseForm = {}

        if (!graduationYear?.value.length) {
            errors = {...errors, graduationYear: 'Please select your graduation year'};
        }

        if(!isHygienistOrAssistant && !education?.value.length) {
            errors = {...errors, education: 'Please enter your School or Institute'};
        }

        if(!isQualificationFilled) {
            setQualificationFilled(false);
        }

        if(!isWorkExperienceFilled) {
            setWorkExperienceFilled(false);
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            TempStars.Analytics.track('sign-up - Failed to Save Profile', {failedFields: Object.keys(errors)});
        }

        if((!isQualificationFilled && isHygienistOrAssistant) || !graduationYear?.value.length || !isWorkExperienceFilled || (!isHygienistOrAssistant && !education?.value.length)) {
            return;
        }

        if (!isAboutFilled && !skipAboutMe) {
            setAboutMeCompletedModal(true);
            return;
        }
        app.showPreloader('Setting Up Profile');

        baseForm = {
            ...baseForm,
            hygienistId: hygienistId,
            graduationYear: graduationYear.value,
            isComplete: 1,
            starScore: 4,
        };

        if(!isHygienistOrAssistant) {
            baseForm = {
                ...baseForm,
                school: education?.value,
            }
        }

        if(about?.length) {
            baseForm = {
                ...baseForm,
                about: about,
            };
        }

        if (checkedSkills.find(skill => skill.name === 'RH')) {
            baseForm = {
                ...baseForm,
                isRestorative: 1,
            }
        }
        if (checkedSkills.find(skill => skill.name === 'OH')) {
            baseForm = {
                ...baseForm,
                isOrtho: 1,
            }
        }

        if (imageSrc) {
            const photoFileName = await uploadPhoto(imageSrc, photoUrl, userAccount.id, errorMessage, setErrorMessage);
            if (photoFileName) {
                baseForm = {
                    ...baseForm,
                    photoUrl: photoFileName,
                };
            }
        }

        if(isLeftHanded) {
            baseForm = {
                ...baseForm,
                isLeftHanded: LEFT_HANDED_OPTIONS.LEFT_HANDED,
            }
        }

        
        try {
            if (isHygienistOrAssistant) {
                const checkedSkillIds = checkedSkills.map((skill: HygienistSkill) => skill.id)
                const resultSkills = qualification?.value ? [...checkedSkillIds, Number(qualification.value)] : checkedSkillIds;
                const arraySkillIds = Array.from(new Set(resultSkills))
                await Api.replaceHygienistSkills(arraySkillIds);

                const userAccount = TempStars.User.getCurrentUser();
                const checkForDuplicateHygienist = await Api.checkForDuplicateHygienist(hygienistId, hygienist?.firstName, hygienist?.lastName, userAccount.id, hygienist?.type, hygienist?.province)
                duplicate = checkForDuplicateHygienist.isDuplicate
            }

            await Api.updateHygienistSignup({...formData, ...baseForm})
            await TempStars.User.updateRegistration()
            await TempStars.User.reLogIn();
            const userAccount = TempStars.User.getCurrentUser();
            await Api.updateToken()
            setUser(userAccount)
            sendAnalytic(userAccount)

            app.hidePreloader();
            if (roleNumber === roles.ASSOCIATE_DENTIST || roleNumber === roles.FRONT_DESK) {
                hygienistMenuInit(userAccount)
                const {hygienist} = userAccount;
                const props = {
                    userType: "Dental Worker",
                    userStatus: 'Active',
                    country: hygienist.countryStr,
                    province: hygienist.province,
                    $email: hygienist.email,
                    userRole: userRoleAnalytics,
                }
                TempStars.Analytics.setProfileProperties({
                    ...props,
                    graduationYear: hygienist.graduationYear + '-01-01',
                });
                TempStars.Analytics.register({
                    ...props,
                    appType: window.cordova ? 'Mobile' : 'Web',
                })
                TempStars.Analytics.track('sign-up - complete profile');
                history.push({
                    pathname: 'jobPostsList'
                })
            } else {
                TempStars.Analytics.track('sign-up - complete profile');
                history.push('loading');
                if (!duplicate && (roleNumber===roles.HYGIENIST || roleNumber===roles.ASSISTANT)) {
                    return history.push({pathname: 'Onboarding_Talent'}, {firstName: hygienist?.firstName})
                } else {
                    if(duplicate) {
                        TempStars.Analytics.track('Select-Route', {
                            route_selected: 'route_duplicate'
                        });
                    }
                    return TempStars.App.gotoStartingPage()
                }
            }
        } catch (e: any) {
            const userAccount = TempStars.User.getCurrentUser();
            app.hidePreloader();
            TempStars.Analytics.track('sign-up - error', { errorReason: e?.error?.message });

            if (e?.error?.message === 'Duplicate phone') {
                setScreenError('This phone is already in use.')
                return;
            } 
            
            if (e?.error?.message === 'Duplicate') {
                app.modal({
                    title: 'Possible Account Duplicate?',
                    text: `
                    It looks like this might be a duplicate membership account.<br><br>

                    If you already have an account, you can go back to the sign in screen and use "Forgot Password" to login to your account. <br><br> 

                    If you're sure you don't already have an account, contact Member Support, and we'll help get you going. 
                    `,
                    buttons: [
                        { 
                            text: 'Sign In', 
                            onClick: () => {
                                completeSignUpWithErrors(userAccount);
                            }
                        },
                        { 
                            text: 'Contact Support', 
                            onClick: () => {
                                contactSupport();
                                completeSignUpWithErrors(userAccount);
                            }
                        }
                    ]
                });
            } else {
                app.modal({
                    title: 'Account creation Error',
                    text: `Please, contact support with your account userId: ${userAccount.id}`,
                    buttons: [
                        { 
                            text: 'Contact Support', 
                            onClick: () => {
                                contactSupport();
                                completeSignUpWithErrors(userAccount);
                            }
                        },
                        { 
                            text: 'OK', 
                            onClick: () => {}
                        },
                    ]
                });
            }
            console.error(e?.message || e);
            return;
        }
    };

    const openQualificationModal = (e: any) => {
        e.preventDefault();
        setOpenQualificationModal(!isOpenQualificationModal);
    }

    const openPositionModal = (e: any) => {
        e.preventDefault();
        setOpenPositionModal(!isOpenPositionModal);
    }

    const openAboutModal = (e: any) => {
        e.preventDefault();
        setOpenAboutModal(!isOpenAboutModal);
    }

    const webPhotoHandler = (photoUrl: any) => {
        const f = photoUrl.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            event && setImageSrc(event?.target?.result as string)
        };
        reader.readAsDataURL(f);
    }

    let type = undefined;
    let label = '';
    let labelDescription = '';
    let noLicenseLabel = '';
    let noLicenselabelDescription = '';

    if (isHygienistOrAssistant) {
        type = roleNumber === roles.HYGIENIST ? HYGIENIST_TYPES.HYGIENIST : HYGIENIST_TYPES.ASSISTANT;
    }
    const licenseSkill = skills.find(skill => skill.license && !skill.qualification)
    const qualificationSkills = skills.filter((skill: HygienistSkill) => skill.qualification && !skill.license)
    const licenseQualificationSkill = skills.find(skill => skill.license && skill.qualification)
    if(licenseSkill) {
        label = licenseSkill.name === 'RDH'
            ? 'I am an Actively Licensed Registered Dental Hygienist (RDH)'
            : 'I am a Certified or Registered Dental Assistant';
        labelDescription = licenseSkill.name === 'RDH'
            ? `This means you are formally trained, qualified and have an active RDH license in good standing with your regulatory body and can legally work as a Dental Hygienist in ${province}.`
            : `This means you have received formal training as a Dental Assistant and have an active Certification or Registration in good standing in ${province}.`;
    }
    if (licenseQualificationSkill) {
        noLicenseLabel = `I am not a Certified or Registered Dental Assistant`
        noLicenselabelDescription = `The means that you have been trained on-the-job to a high level of competency and professionalism, and are skilled and qualified to work as a dental assistant in ${province}`
    }

    const onSubmitSkills = async (event: any) => {
        event.preventDefault()
        let errors = {}
        let skillsQualificationsForm = {}
        setErrorMessage(errors as ErrorProps);
        const {license, education, qualification} = event.target
        const checkedSkills = skills.filter((skill: HygienistSkill) => event.target[skill.name]?.checked)
        setCheckedSkills(checkedSkills);
        if(licensed || !licenseQualificationSkill) {
            if (!licensed && roles.HYGIENIST === roleNumber) {
                errors = {...errors, licensed: 'Please confirm your qualification'};
            }
            if (roles.HYGIENIST === roleNumber && !license.value.length) {
                errors = {...errors, license: `Please enter your License #`};
            }
            if (roles.ASSISTANT === roleNumber && userQualification === 'CDA2' && province === 'ON' && !license.value.length) {
                errors = {...errors, license: `Please enter your Certificate #`};
            }

            if (licensed && roles.HYGIENIST === roleNumber) {
                try {
                    const checkCDHONumber = await Api.checkUniqueHygienistCDHONumber({ CDHONumber: license.value, type: getTypeByRoleNumber(roleNumber), province: province })
                    if (checkCDHONumber.isDuplicate) {
                        errors = {...errors, license: 'Oops! This license number seems to already be in use.'};
                    }
                } catch (e: any) {
                    errors = {...errors, license: 'Oops! This license number seems to already be in use.'};
                }
            }
            if(licensed && roles.ASSISTANT === roleNumber && !userQualification) {
                errors = {...errors, qualification: 'Please select a qualification level'};
            }
            if (!education?.value.length) {
                errors = {...errors, education: 'Please enter your School or Institute'};
            }
        }
        if(isHygienistOrAssistant && licensed === undefined) {
            errors = {...errors, licensed: 'Please confirm your qualification'};
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            setQualificationFilled(false);
            document.querySelector( '#bodySignUp' )?.scrollIntoView( { behavior: 'smooth', block: 'start' } );
            TempStars.Analytics.track('sign-up - Failed to Save Qualifications and Skills', {failedFields: Object.keys(errors)});
            return console.log('ERROR', errors);
        }
        setQualificationFilled(true);
        if (license?.value) {
            skillsQualificationsForm = {
                ...skillsQualificationsForm,
                CDHONumber: license.value,
            };
        }
        if (qualification?.value) {
            const qualificationSkill = JSON.parse(qualification.value);
            setCheckedSkills([...checkedSkills, qualificationSkill]);
            let level = qualificationSkill.id === 3 ? 2 : 1;
            skillsQualificationsForm ={
                ...skillsQualificationsForm,
                level: level,
            };
        }
        skillsQualificationsForm = {
            ...skillsQualificationsForm,
            school: education?.value,
        };

        if (roleNumber === roles.ASSISTANT && !checkedSkills.some(skill => ['TDX', 'PSIC', 'CPRC'].includes(skill.name))) {
            setAssistantSkillsCheckModal(!isAssistantSkillsCheckModal)
        } else {
            TempStars.Analytics.track('sign-up - Saved Qualifications and Skills');
            setAssistantSkillsCheckModal(false);
            setOpenQualificationModal(false)
        }
        setFormData(skillsQualificationsForm);
    }

    const graduateYears = [];
    for (let i = new Date().getFullYear(); i >= 1960; i--) {
        graduateYears.push(i);
    }

    const schoolHandler = (e: any) => {
        if(e.target.value) {
            setErrorMessage({ ...errorMessage, education: '' });
        }
    }

    const licenseHandler = (e: any) => {
        if(e.target.value) {
            setErrorMessage({ ...errorMessage, license: '' });
        }
    }

    const qualificationHandler = (e: any) => {
        setUserQualification(JSON.parse(e.target.value).name)
        if(e.target.value) {
            setErrorMessage({...errorMessage, qualification: ''})
        }
    }

    const [changeRoleLoading, , changeRole] = useActionApi({
        apiMethod: Api.changeRole,
        onSuccess: () => history.push({pathname: 'SignUp1_DO'}),
    });

    const changeRoleToDentist = async () => {
        TempStars.Analytics.track('Select-Route', {
            route_selected: 'UserToDentalOffice'
        });
        await Api.deleteHygienist(Number(hygienistId))
        changeRole(roles.DENTIST);
    }

    const handleAssistantSkillsCheckModalClose = () => {
        setAssistantSkillsCheckModal(!isAssistantSkillsCheckModal);
        setOpenQualificationModal(false);
    }

    const handleAboutMeCompletedModalClose = () => {
        setAboutMeCompletedModal(false);
        setSkipAboutMe(true);
    };

    const handleCompleteAboutMe = () => {
        setAboutMeCompletedModal(false);
        setOpenAboutModal(true);
    };

    return (
        <Page>
            <Container>
                <SimpleModal isOpen={isAboutMeCompletedModal}>
                    <AboutMeCompletedModal
                        onClose={handleAboutMeCompletedModalClose}
                        onCompleteAboutMe={handleCompleteAboutMe}
                    />
                </SimpleModal>
                <div className={"bodySignUp contentBlock"} id={"bodySignUp"}>
                {isHygienistOrAssistant ?
                    <FullscreenModal
                        title={'Qualification & Skills'}
                        isOpen={isOpenQualificationModal}
                        buttonText={'Save'}
                        onClose={() => setOpenQualificationModal(false)}
                        onSubmit={onSubmitSkills}
                        stickyBottom={true}
                        isSignUpPage={true}
                    >
                        <SimpleModal isOpen={isLeftHandedModal}>
                            <LeftHandedModal onCloseButtonClick={() => setIsLeftHandedModal(false)}/>
                        </SimpleModal>
                        <SimpleModal isOpen={isAssistantSkillsCheckModal}>
                            <AssistantSkillsCheckModal
                                onClose={() => setAssistantSkillsCheckModal(!isAssistantSkillsCheckModal)}
                                onSaveAndContinue={handleAssistantSkillsCheckModalClose}
                            />
                        </SimpleModal>
                      
                      
                        {licenseSkill ? <FormControlLabel
                            className={'labelContainer inset no-fastclick'}
                            control={
                                licenseQualificationSkill ?
                                    <Radio
                                        name={licenseSkill.name}
                                        checked={licensed === true}
                                        value={licensed}
                                        onChange={(e) => {
                                            setDisabledSkills(!e.target.checked)
                                            setLicensed(true)
                                            setErrorMessage({ ...errorMessage, licensed: false });
                                        }}
                                        icon={
                                            <img id="circleUnchecked" className="hidden-icon" alt=""
                                                 src={"img/circleUnchecked.svg"}/>
                                        }
                                        checkedIcon={
                                            <img id="circleChecked" className="hidden-icon" alt=""
                                                 src={"img/circleChecked.svg"}/>}
                                    />
                                    : <Checkbox
                                        name={licenseSkill.name}
                                        checked={licensed === true}
                                        value={licensed}
                                        onChange={(e) => {
                                            setDisabledSkills(!e.target.checked)
                                            setLicensed(e.target.checked)
                                            setErrorMessage({ ...errorMessage, licensed: false });
                                        }}
                                        icon={<img id="checkboxUnchecked" className="hidden-icon" alt=""
                                                   src={"img/checkboxUnchecked.svg"}/>}
                                        checkedIcon={<img id="checkboxChecked" className="hidden-icon" alt=""
                                                          src={"img/checkboxChecked.svg"}/>}
                                    />
                            }
                            label={<Label
                                style={{color: errorMessage?.licensed ? '#f44336' : ''}}
                                label={label}
                                description={labelDescription}
                            />}
                        /> : ''
                        }
                        {!!qualificationSkills.length &&
                            <div className="list-block inset inputBox">
                                <MaterialSelector
                                    disabled={disabledSkills || !licensed}
                                    id={'qualification'}
                                    name={'qualification'}
                                    label={'Qualification'}
                                    errorMessage={errorMessage?.qualification}
                                    onChange={qualificationHandler}
                                >
                                    {
                                        qualificationSkills.map((skill: HygienistSkill) => {
                                            return (<MenuItem value={JSON.stringify(skill)} id={skill.name}>{skill.label}</MenuItem>)
                                        })
                                    }
                                </MaterialSelector>
                            </div>}
                        <div className="list-block inset inputBox">
                            <MaterialInput
                                disabled={isHygienistOrAssistant && (disabledSkills || !licensed)}
                                className={'styledInput'}
                                label="School / Institute"
                                id={'education'}
                                name={"education"}
                                type={"text"}
                                onChange={schoolHandler}
                                error={!!errorMessage?.education}
                                helperText={!!errorMessage?.education && errorMessage.education}
                            />
                        </div>
                        {license && <div className="list-block inset inputBox">
                            <MaterialInput
                                disabled={disabledSkills || !licensed}
                                inputRef={htmlElRef}
                                className={'licenseBox'}
                                label={license}
                                onChange={licenseHandler}
                                type={"text"}
                                id={'license'}
                                name={"license"}
                                error={!!errorMessage?.license}
                                helperText={roleNumber === roles.ASSISTANT
                                    ? userQualification === 'CDA2'
                                     ? !!errorMessage?.license && errorMessage.license || '(Required)'
                                     : '(Optional)'
                                    : !!errorMessage?.license && errorMessage.license}
                            />
                        </div>}
                        {roleNumber === roles.HYGIENIST &&
                        <div className="isLeftHandedContainer">
                            <FormControlLabel
                                className={'labelContainer__leftHanded inset no-fastclick'}
                                control={<Checkbox
                                        name={"I'm left-handed"}
                                        checked={isLeftHanded}
                                        value={isLeftHanded}
                                        onChange={(e) => {
                                            setIsLeftHanded(e.target.checked)
                                        }}
                                        icon={<img id="checkboxUnchecked" className="hidden-icon" alt=""
                                                   src={"img/checkboxUnchecked.svg"}/>}
                                        checkedIcon={<img id="checkboxChecked" className="hidden-icon" alt=""
                                                          src={"img/checkboxChecked.svg"}/>}
                                        disabled={disabledSkills || !licensed}
                                    />
                            }
                            label={<Label
                                style={{color: errorMessage?.licensed ? '#f44336' : ''}}
                                label={"I'm left-handed"}
                                description={""}
                            />}
                        />
                        
                            <InfoOutlinedIcon className="infoIcon" onClick={() => setIsLeftHandedModal(true)}/>
                        </div>
                        }

                        {licenseQualificationSkill ? <FormControlLabel
                            className={'labelContainer inset no-fastclick'}
                            control={<Radio
                                checked={licensed === false}
                                value={!licensed}
                                name={licenseQualificationSkill.name}
                                onChange={(e) => {
                                    setDisabledSkills(!e.target.checked)
                                    setLicensed(false)
                                }}
                                icon={<img id="circleUnchecked" className="hidden-icon" alt=""
                                           src={"img/circleUnchecked.svg"}/>}
                                checkedIcon={<img id="circleChecked" className="hidden-icon" alt=""
                                                  src={"img/circleChecked.svg"}/>}
                            />}
                            label={<Label
                                label={noLicenseLabel}
                                description={noLicenselabelDescription}
                            />}
                        /> : ''}
                        {typeof type === 'number' ? 
                            <AdditionalSkills
                                disabled={disabledSkills}
                                skills={skills}
                                checkedSkills={checkedSkills}
                                state={province || ''}
                                qualificationSkill={qualificationSkills.find(skill => skill.name === userQualification)}
                            /> 
                        : ''}
                        </FullscreenModal> : null}

                    <AboutYou
                        about={about}
                        name={hygienist?.firstName}
                        isOpen={isOpenAboutModal}
                        onSaveAbout={setAbout}
                        onClose={() => setOpenAboutModal(false)}
                    />

                    <WorkExperience
                        country={country || 0}
                        isOpen={isOpenPositionModal}
                        onSaveExperience={() => setWorkExperienceFilled(true)}
                        onClose={() => setOpenPositionModal(false)}
                        isHygienistOrAssistant={isHygienistOrAssistant}
                    />

                    <div style={{display: isOpenQualificationModal || isOpenPositionModal || isOpenAboutModal ? 'none' : ''}}>
                        <HeaderStatusBar buttonClassName={'logout-link'} buttonText={'Sign Out'} withArrow/>
                        <form
                            id="signup-form"
                            className="content-block contentBlock"
                            onSubmit={onSubmit}
                        >
                            <ChangeRoleBlock><a onClick={changeRoleToDentist}>Are you a Dental Office? Register here</a></ChangeRoleBlock>
                            <div className="list-block inset inputBox photoBox">
                                <HiddenInput
                                    type='file'
                                    name={'photoUrl'}
                                    ref={inputPhotoRef}
                                    onChange={(e: any) => webPhotoHandler(e.target)}
                                    accept="image/gif,image/jpeg,image/png,image/jpg,image/*"
                                    title="Upload profile photo"
                                    aria-label="Upload profile photo"
                                />

                                <div
                                    className={'profile-photo-parent no-fastclick'}
                                    onClick={() => {
                                        imageSrc
                                            ? setImageSrc(undefined)
                                            : inputPhotoRef.current?.click()
                                    }}
                                >
                                    {imageSrc
                                        ? <img className={'photoImg'} src={imageSrc} alt="profilePhoto"/>
                                        : <CameraIcon/>
                                    }
                                </div>

                                <div className="nameBox">
                                    {hygienist?.firstName} {hygienist?.lastName}{userQualificationTitle && `, ${userQualificationTitle}`}
                                </div>
                            </div>

                            <div className="list-block inset inputBox">
                                <MaterialSelector
                                    id={'graduationYear'}
                                    name={'graduationYear'}
                                    label={'Graduation Year'}
                                    errorMessage={errorMessage?.graduationYear}
                                    onChange={() => setErrorMessage({...errorMessage, graduationYear: ''})}
                                >
                                    {graduateYears.map(year => <MenuItem value={year}>{year}</MenuItem>)}
                                </MaterialSelector>
                            </div>
                            {!isHygienistOrAssistant ?
                            <div className="list-block inset inputBox">
                            <MaterialInput
                                className={'styledInput'}
                                label="School / Institute"
                                id={'education'}
                                name={"education"}
                                type={"text"}
                                onChange={schoolHandler}
                                error={!!errorMessage?.education}
                                    helperText={!!errorMessage?.education && errorMessage.education}
                                />
                            </div> : null}

                            {isHygienistOrAssistant ?
                            <div
                                className={clsx("roundedBox no-fastclick inset", isQualificationFilled === false && 'errorBox')}
                                onClick={openQualificationModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isQualificationFilled}
                                            header={'Qualification & Skills'}
                                            description={isQualificationFilled ? 'Completed' : 'Required'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Let Dental Offices know about your specific training and skills
                                        </div>
                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div> : null}
                            {isQualificationFilled === false && isHygienistOrAssistant ? (
                            <ErrorDescription>
                                Fill out your skills so we can show you all applicable jobs in your area.
                            </ErrorDescription>
                            ) : null}

                            <div
                                className={clsx("roundedBox no-fastclick inset", isWorkExperienceFilled === false && 'errorBox')}
                                onClick={openPositionModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isWorkExperienceFilled}
                                            header={'Work Experience'}
                                            description={isWorkExperienceFilled ? 'Completed' : 'Required'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Show Dental Offices your professional experience in the dental industry
                                        </div>
                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div>
                            {isWorkExperienceFilled === false && (
                            <ErrorDescription>
                                Let Dental Offices know about your specific work history. Even if you're a new grad, add in volunteer work or other jobs to get you started.
                            </ErrorDescription>
                            )}
                            <div
                                className={clsx("roundedBox no-fastclick inset")}
                                onClick={openAboutModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isAboutFilled}
                                            header={'About You'}
                                            description={isAboutFilled ? 'Completed' : 'Optional'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Write a bio or we can magically write one for you.
                                        </div>

                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div>

                            <div className={'list-block inset inputBox bottomText'}>
                                Complete your profile so you can really shine & get access to those shifts and postings you really want!
                            </div>

                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                id="signup-button"
                                className="bigButtonInNewStyle"
                                type={'submit'}
                            >
                                Finish Sign Up
                            </Button>
                        </form>
                    </div>
                </div>

                <div className="footer">
                </div>
            </Container>
            <FixedLoader loading={ changeRoleLoading }/>
        </Page>
    )
}